import { supabase } from '../supabaseClient';

export const MIN_PASSWORD = 8;

// Sin caracteres que se confunden al dictarlos por WhatsApp (0/O, 1/l/I).
const ALPHABET = 'abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export function generatePassword(length = 10) {
  const bytes = new Uint32Array(length);
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, (n) => ALPHABET[n % ALPHABET.length]).join('');
}

export function validateBusinessLogin({ email, password }) {
  const mail = String(email ?? '').trim().toLowerCase();
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) return { ok: false, error: 'Escribe un correo válido (puede ser de cualquier proveedor).' };
  const pass = String(password ?? '');
  if (pass.length < MIN_PASSWORD) return { ok: false, error: `La contraseña debe tener al menos ${MIN_PASSWORD} caracteres.` };
  if (pass.length > 72) return { ok: false, error: 'La contraseña no puede pasar de 72 caracteres.' };
  return { ok: true, value: { email: mail, password: pass } };
}

const ERRORS = {
  no_autorizado: 'Solo un administrador master con sesión iniciada puede crear accesos. Cierra sesión y entra con tu cuenta de Google de administrador.',
  correo_invalido: 'Ese correo no es válido.',
  clave_invalida: `La contraseña debe tener entre ${MIN_PASSWORD} y 72 caracteres.`,
  negocio_no_existe: 'El negocio ya no existe. Actualiza la lista.',
  correo_distinto: 'Este negocio ya entra con otro correo. Usa ese mismo correo o cámbialo antes en la ficha del negocio.',
  correo_en_uso: 'Ese correo ya pertenece a otro negocio.'
};

export function loginErrorMessage(error) {
  const text = `${error?.message || ''} ${error?.details || ''}`;
  const known = Object.keys(ERRORS).find((key) => text.includes(key));
  if (known) return ERRORS[known];
  if (error?.code === 'PGRST202' || error?.code === '42883' || /admin_set_business_login/.test(text)) {
    return 'Falta ejecutar la migración 20261002a_business_login.sql en Supabase.';
  }
  return 'No se pudo guardar el acceso. Intenta de nuevo.';
}

// Crea (o cambia la contraseña de) el acceso de un negocio. Devuelve { ok, email, created } o { ok: false, error }.
export async function setBusinessLogin(businessId, { email, password }) {
  const check = validateBusinessLogin({ email, password });
  if (!check.ok) return check;
  const { data, error } = await supabase.rpc('admin_set_business_login', {
    p_business_id: String(businessId), p_email: check.value.email, p_password: check.value.password
  });
  if (error) return { ok: false, error: loginErrorMessage(error) };
  return { ok: true, email: data?.email || check.value.email, created: Boolean(data?.created) };
}

export function accessMessage({ businessName, email, password, url = 'https://keyla.seryiads.com/login' }) {
  return `Hola 👋 Ya quedó listo el acceso de ${businessName} a Keyla CRM.\n\nIngresa en ${url}\nCorreo: ${email}\nContraseña: ${password}\n\nTe recomiendo guardarla en un lugar seguro.`;
}
